module.exports = __webpack_public_path__ + "static/media/sevenSeasSm.d618a1f8.gif";